import microApp from '../micro_app'
/**
 * 获取静态资源
 * TODO: 更多资源类型适配，如 blob、Content-Type、非UTF-8编码类型 等
 * @param url 静态资源地址
 */
export function fetchSource (url: string, config = {}): Promise<string> {
  if (typeof microApp.fetch === 'function') {
    return microApp.fetch(url, config)
  }

  return fetch(url, config).then((res) => {
    return res.text()
  })
}
